import { DISPLAY_PAGES } from '@nerdwallet/react-banking-product-cta';
export { DISPLAY_PAGES };
export var LINK_TYPES = {
  BUTTON: 'BUTTON',
  LINK: 'LINK'
};
export var RATES_LINK_EDUCATION_LOANS = 'https://www.nerdwallet.com/refinancing-student-loans/pre-qualify';
export var RATES_LINK_PERSONAL_LOANS = 'https://www.nerdwallet.com/personal-loans/pre-qualify/step-1';
export var TRK_PRODUCT_LOCATION = 'MarketplaceApplyNow';